import React from 'react';
import { Grid, Typography } from '@mui/material';
import imgDetail from '../../assets/quienesSOMOS.webp';
import imgDetail2 from '../../assets/queOfrecemos.webp';

const GetStarted = () => {

  const palette = {
    lightGray: '#718895',
    brightGray: 'rgb(192, 199, 199)',
    mutedBlueGray: 'rgb(187, 196, 197)',
  };

  const sectionStyles = {
    py: 4,
    px: { xs: 3, sm: 6, md: 10 },
    backgroundColor: '#ffffff',
    maxWidth: '100%',
    margin: '0 auto',
  };

  const titleStyles = {
    fontWeight: 'bold',
    color: 'rgb(41, 54, 54)',
    mb: 2,
    fontSize: '2rem',
  };

  const textStyles = {
    lineHeight: '1.8',
    color: '#000000',
    textAlign: 'justify',
  };

  return (
    <Grid container spacing={4} sx={sectionStyles}>
      {/* Sección: ¿Quiénes somos? */}
      <Grid container spacing={4} sx={{ ...sectionStyles, mb: 0 }}>
        <Grid item xs={12} md={6}>
          <Typography variant="h4" sx={titleStyles}>
            ¿Quiénes <span style={{ color: palette.lightGray }}>somos?</span>
          </Typography>
          <Typography variant="body1" sx={textStyles}>
            Somos una institución educativa especializada en la formación de profesionales en el área de ultrasonido diagnóstico.
            Nos enorgullece contar con un equipo de docentes altamente capacitados, tecnología de vanguardia y un enfoque práctico que
            garantiza una experiencia de aprendizaje enriquecedora. Nuestro compromiso es formar expertos que contribuyan al diagnóstico
            y cuidado de la salud con los más altos estándares de calidad.
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <img
            src={imgDetail}
            alt="Quiénes somos"
            style={{
              width: '100%',
              borderRadius: '16px',
            }}
            loading="lazy"
          />
        </Grid>
      </Grid>

      {/* Sección: ¿Qué ofrecemos? */}
      <Grid container spacing={4} sx={{ ...sectionStyles, py: 1 }}>
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            order: { xs: 1, md: 2 }, // Texto siempre arriba en móvil
          }}
        >
          <Typography variant="h4" sx={titleStyles}>
            ¿Qué <span style={{ color: palette.lightGray }}>ofrecemos?</span>
          </Typography>
          <Typography variant="body1" sx={textStyles}>
            Ofrecemos diplomados y programas especializados en ultrasonido diagnóstico diseñados para médicos generales,
            especialistas y otros profesionales de la salud interesados en adquirir o perfeccionar sus habilidades en esta área.
            Contamos con cursos adaptados a diferentes niveles de experiencia, desde el Diplomado Básico hasta la Maestría en Ultrasonido
            Diagnóstico, todos ellos con énfasis en la aplicación práctica y el uso de equipos modernos.
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            order: { xs: 2, md: 1 },
          }}
        >
          <img
            src={imgDetail2}
            alt="Qué ofrecemos"
            style={{
              width: '100%',
              borderRadius: '16px',
            }}
            loading="lazy"
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default React.memo(GetStarted);
